<template>
	<div class="grade">
		<div v-if="gradeList.length===0" class="nodata-page" data-msg="暂时没有班级哦~"></div>
		<div v-for="(item,index) in gradeList" :key="index" class="card flex">
			<div class="title flex center">班级</div>
			<div @click="toGradeHome(item)" class="info">
				<span class="text-ellipsis">{{item.name}}</span>
				<span>共{{item.number}}个学生</span>
			</div>
		</div>

		<div class="fixed-bottom flex center">
			<button @click="toCreateGrade" class="btn-full">新建班级</button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			courseInfo:{},
			gradeList: [],
		};
	},

	mounted() {
		this.courseInfo = JSON.parse(this.$route.query.courseInfo);
		this.getGradesByCourseId(this.courseInfo.id);
	},

	methods: {
		toGradeHome(item) {
			this.$router.push({path:'/manager/course/grade/home',query:{gradeId:item.id}});
		},
		toCreateGrade() {
			localStorage.removeItem("selectStudents")
			this.$router.push(`/manager/course/grade/create?courseId=${this.courseInfo.id}`);
		},

		async getGradesByCourseId(courseId) {
			try {
				let {success,message,result} = await this.$http.get(`h5/teacherTeam/getTeam?courseId=${courseId}`)
				if (!success) throw new Error(message);
				this.gradeList = result;
			} catch (error) {
				console.error("getGradesByCourseId", error?.message);
			}
		},
	},
};
</script>


<style lang="less" scoped>
.grade {
	height: 100%;
	padding: 0 17 / @rem 80 / @rem;
	.card {
		width: 100%;
		height: 66 / @rem;
		border-radius: 12 / @rem;
		padding: 0 12 / @rem 0 15 / @rem;
		margin-bottom: 11 / @rem;
		background-color: rgba(255, 162, 22, 0.1);
		position: relative;
		&::after {
			content: "";
			display: block;
			width: 15 / @rem;
			height: 15 / @rem;
			background-image: url(~@img/icon/btn_xl.png);
			background-repeat: no-repeat;
			background-size: contain;
		}
		.title {
			width: 59 / @rem;
			height: 42 / @rem;
			border-radius: 12 / @rem;
			background-color: #ffa216;
			color: white;
			font-size: 16 / @rem;
		}
		.info {
			flex: 1;
			width: 100%;
			padding-left: 11 / @rem;
			span:first-child {
				width: 210 / @rem;
				color: #171819;
				font-size: 14 / @rem;
				font-weight: bold;
				font-family: Source Han Sans CN-Medium, Source Han Sans CN;
			}
			span:last-child {
				color: rgba(31, 30, 29, 0.3);
				font-size: 11 / @rem;
				font-family: Source Han Sans CN-Regular, Source Han Sans CN;
			}
		}
	}

	.fixed-bottom {
		height: 80 / @rem;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: white;
		padding: 0 17 / @rem;
	}
}
</style>
